var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "accent",
    d: "M10.25 11.75v2c0 .41.34.75.75.75s.75-.34.75-.75v-2h2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2v-2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2h-2c-.41 0-.75.34-.75.75s.34.75.75.75h2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 .75a.75.75 0 0 0-.75-.75H.75A.75.75 0 0 0 0 .75v12.5c0 .414.336.75.75.75H2a.75.75 0 0 0 0-1.5h-.5v-11h11V2A.75.75 0 0 0 14 2V.75ZM4.75 4a.75.75 0 0 0-.75.75v12.5c0 .414.336.75.75.75h12.5a.75.75 0 0 0 .75-.75V4.75a.75.75 0 0 0-.75-.75H4.75Zm.75 12.5v-11h11v11h-11Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGallery);
export default __webpack_public_path__ + "static/media/addGallery.7621d946425259e8edcec5df7a79a008.svg";
export { ForwardRef as ReactComponent };